import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: ({ backgroundStyles }) => ({
    ...backgroundStyles,
    color: theme.palette.common.white,
    padding: '2.875rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
    },
  }),
  heading: {
    color: theme.palette.gold.main,
    marginBottom: '.625rem',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'initial',
    },
  },
  body: {
    marginBottom: '2.5rem',
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'initial',
    },
  },
  ctaContainer: {
    display: 'flex',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  secondaryCta: {
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginLeft: 0,
      marginTop: theme.spacing(2),
    },
  },
}))

export default useStyles
